import { CONNECTION_COPY, type ConnectionStatus } from '@tradeoutlet/shared';

/**
 * t412u / t574u: plain-language wording for the sidebar's connection icon (hover text and screen readers). The status
 * comes from the shared ConnectionMonitor, which only reports a problem once it has lasted a few seconds.
 */

export function connectionLabel(status: ConnectionStatus): string {
  return CONNECTION_COPY[status];
}
